import React from "react";
import ReactDOM from "react-dom";
import "./style.css";
import Home from "./core/Home";
import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>,
  document.getElementById("root")
);
